import { render, staticRenderFns } from "./FeedUser.vue?vue&type=template&id=0d516722&scoped=true&"
import script from "./FeedUser.vue?vue&type=script&lang=ts&"
export * from "./FeedUser.vue?vue&type=script&lang=ts&"
import style0 from "./FeedUser.vue?vue&type=style&index=0&id=0d516722&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d516722",
  null
  
)

export default component.exports